"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _isNil = _interopRequireDefault(require("./isNil"));

/**
 * Remove keys with nil values from an object
 * @param inObject
 * @return {Object} inObject with keys removed
 */
var removeUnusedKeys = function removeUnusedKeys(inObject) {
  if ((0, _isNil["default"])(inObject)) return inObject; // remove undefined properties

  var keys = Object.keys(inObject);
  keys.forEach(function (key) {
    if ((0, _isNil["default"])(inObject[key])) {
      delete inObject[key];
    }
  });
  return inObject;
};

var _default = removeUnusedKeys;
exports["default"] = _default;